export const INITIAL_FORM_DATA = {
  name: '',
  date: '',
  position: '',
  department: '',
  supervisor: '',
  dateOfHire: '',
  policyViolationIds: [] as string[],
  reasonForPerformanceImprovementPlan: '',
  expectationsAndGoals: '',
  timelineAndDeadline: '',
  resourcesAndSupport: '',
  privateNotes: '',
};
